export const maxScreenshots = 4